import React, { ReactNode } from "react";
import {
    Alert,
    Paper,
    Slide,
    Snackbar,
    Grid,
    useTheme,
    Typography,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import {
    AlertCircleOutline,
    CheckboxMarkedCircleOutline,
} from "mdi-material-ui";

const useStyles = makeStyles()((theme) => {
    return {
        colorPrimary: {
            height: 5,
            backgroundColor: "white",
        },
        progressBar: {
            width: "100%",
        },
    };
});

export default function CustomToast({
    appearance,
    children,
    autoDismissTimeout,
}: {
    appearance: string;
    children: ReactNode;
    autoDismissTimeout: number;
}) {
    const classes = useStyles();
    const theme = useTheme();

    const barColor = appearance === "error" ? "red" : "green";
    const duration = autoDismissTimeout / 1000;

    return (
        <Slide direction="left" in={true}>
            <Paper
                style={{
                    overflow: "hidden",
                    marginTop: "1rem",
                    width: 350,
                    maxWidth: 350,
                }}
            >
                <Grid
                    container
                    alignItems={"center"}
                    style={{
                        //recode  primaryColor -> ThemeProvider as parent
                        color: appearance === "error" ? "red" : "green",
                        boxShadow: theme.shadows[4],
                        padding: "0.5rem",
                    }}
                    spacing={2}
                >
                    <Grid
                        item
                        container
                        xs={2}
                        style={{ padding: 0, paddingTop: 16, paddingLeft: 16 }}
                    >
                        {appearance === "error" ? (
                            <AlertCircleOutline />
                        ) : (
                            <CheckboxMarkedCircleOutline />
                        )}
                    </Grid>
                    <Grid item xs={10}>
                        <Typography variant={"body2"}>{children}</Typography>
                    </Grid>
                </Grid>
            </Paper>
        </Slide>
    );
}
